{% block sw_settings_content_card_slot_plugins %}
    {% parent %}

    {% block sw_settings_swag_security %}
        <sw-settings-item
            v-if="acl.can('admin')"
            :label="$tc('sw-settings-security.general.mainMenuItemGeneral')"
            :to="{ name: 'sw.settings.security.index' }"
        >
            <template #icon>
                <sw-icon name="regular-shield" />
            </template>
        </sw-settings-item>
    {% endblock %}
{% endblock %}
